import { BRAND } from '@/constants/brand';

/**
 * Logo Xperience oficial.
 * NUNCA rotar, recortar o enmarcar el imagotipo "X".
 */
export default function XperienceLogo({ className = 'w-10 h-10' }) {
  return (
    <>
      <img src='/logo.png' />
    </>
/*   <svg viewBox="0 0 100 100" className={className} aria-label="Xperience">
      <path d="M 25 15 L 50 40 L 75 15 L 65 15 L 50 30 L 35 15 Z" fill={BRAND.gold} />
      <path
        d="M 15 45 L 40 70 L 15 95 L 28 95 L 50 73 L 72 95 L 85 95 L 60 70 L 85 45 L 72 45 L 50 67 L 28 45 Z"
        fill="white"
      />
    </svg>  */
  );
}
